<div class="flex flex-col h-full">
    <h1 class="text-2xl">Services and Filings</h1>
    <div class="flex justify-end">
        <mat-form-field
            appearance="outline"
            class="mb-[-1em] pr-[0.5em] my-1 compact-select"
        >
            <mat-select
                [(value)]="selectedService"
                (selectionChange)="externalFilterChanged()"
                class="!text-sm"
                aria-label="Services Filter"
            >
                @for (service of externalFilterOptions; track service.value) {
                    <mat-option [value]="service.value">
                        {{ service.label }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <app-grid-toolbar
            [gridApi]="gridApi"
            [options]="gridToolbarOptions"
        ></app-grid-toolbar>
    </div>
    <div class="flex-grow">
        <ag-grid-angular
            [context]="context"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            class="ag-theme-quartz h-100p"
        >
        </ag-grid-angular>
    </div>
</div>
